import { Mail, Phone, Globe, MapPin } from "lucide-react";
import SEO from "@/components/SEO";
import { Reveal } from "@/components/Reveal";
import { PageHero, PrimaryLink } from "@/components/site";
import { CONTACT, COMPANY } from "@/data/content";

export default function Contact() {
  return (
    <div data-testid="page-contact">
      <SEO
        title="Contact"
        description="Contact TWORAY Ltd. Email hello@tworay.co.uk or call +44 7947 477 251 to discuss cyber security advisory and technology consulting."
      />
      <PageHero
        overline="Contact"
        title="Let's talk about where you're headed."
        subtitle="Reach us directly, or book a discovery call and we'll come prepared."
      />

      <section className="py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-12">
          <Reveal>
            <div className="space-y-6">
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-4 group" data-testid="contact-email">
                <span className="w-12 h-12 rounded-sm bg-iceblue grid place-items-center text-brandblue"><Mail size={20} /></span>
                <div>
                  <div className="text-xs font-semibold tracking-[0.2em] uppercase text-slate">Email</div>
                  <div className="font-heading font-semibold text-lg text-navy group-hover:text-brandblue transition-colors">{CONTACT.email}</div>
                </div>
              </a>
              <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="flex items-center gap-4 group" data-testid="contact-phone">
                <span className="w-12 h-12 rounded-sm bg-iceblue grid place-items-center text-brandblue"><Phone size={20} /></span>
                <div>
                  <div className="text-xs font-semibold tracking-[0.2em] uppercase text-slate">Phone</div>
                  <div className="font-heading font-semibold text-lg text-navy group-hover:text-brandblue transition-colors">{CONTACT.phone}</div>
                </div>
              </a>
              <div className="flex items-center gap-4">
                <span className="w-12 h-12 rounded-sm bg-iceblue grid place-items-center text-brandblue"><Globe size={20} /></span>
                <div>
                  <div className="text-xs font-semibold tracking-[0.2em] uppercase text-slate">Web</div>
                  <div className="font-heading font-semibold text-lg text-navy">{CONTACT.website}</div>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <span className="w-12 h-12 rounded-sm bg-iceblue grid place-items-center text-brandblue"><MapPin size={20} /></span>
                <div>
                  <div className="text-xs font-semibold tracking-[0.2em] uppercase text-slate">Registered office</div>
                  <div className="text-sm text-slate">{COMPANY.registeredOffice}</div>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="bg-navy rounded-md p-10 text-white grain-overlay relative overflow-hidden">
              <div className="relative z-10">
                <h2 className="font-heading font-bold text-2xl sm:text-3xl">Prefer a structured start?</h2>
                <p className="mt-4 text-white/70 leading-relaxed">
                  Book a discovery call through our short form. You'll get a fast response and, optionally, our full-price brochure.
                </p>
                <PrimaryLink to="/book" dark className="mt-8" data-testid="contact-book-cta">Book a Discovery Call</PrimaryLink>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
